// ⚠️ 레거시 — SubscribeToPass 전용 보유 이용권 체크. /subscribe 와 함께 정리 대상.
import { useAuthStore } from "@/lib/auth/AuthStore";
import { MYPAGE_PASSES, SOLVOOK_WRITE_STUDIO } from "@/settings/constant";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { getMemberships, getPassOneProduct, PassCategory } from "../../../api/membership";
export const errorStatus = {
    alreadySubscribe: 402,
    alreadySolvookPlus: 403
};
const useCheckMyPass = ()=>{
    const { isLoggedIn , user  } = useAuthStore();
    const router = useRouter();
    const { id , orderType  } = router.query;
    if (orderType && orderType !== "pass") return {
        id: undefined,
        errorCode: 200,
        subscribePass: undefined,
        isError: false,
        errorMessages: {}
    };
    const path = router.pathname.includes("subscribe") ? "subscribe" : "checkout";
    const [errorCode, setErrorCode] = useState(200);
    const errorMessages = {
        [errorStatus.alreadySubscribe]: {
            title: "이미 구독중인 상품이에요.",
            content: "상품의 구독정보를 보고 싶으시다면 '이용권 관리 가기'를 눌러주세요.",
            okText: "이용권 관리 가기",
            onOk: ()=>window.location.href = MYPAGE_PASSES
        },
        [errorStatus.alreadySolvookPlus]: {
            title: "이미 쏠북플러스를 이용 중이에요",
            content: "쏠북 플러스 기간동안 엑스퍼트는 추가 결제없이 사용할 수 있어요.",
            okText: "엑스퍼트 사용하기",
            onOk: ()=>window.location.href = SOLVOOK_WRITE_STUDIO
        }
    };
    // 내가 구독중인 상품
    const { data: userMembershipResponse  } = useQuery([
        "userMembership",
        user
    ], ()=>getMemberships({}), {
        onError: (error)=>{
            ;
        },
        enabled: isLoggedIn
    });
    // 구독하려는 상품
    const { data: subscribePass , isError  } = useQuery([
        "getSubscribeProduct",
        id
    ], ()=>getPassOneProduct(Number(id)), {
        retry: false
    });
    const isSamePass = useMemo(()=>{
        if (!userMembershipResponse || !id) return null;
        const checkMyTicket = userMembershipResponse.unexpired.find((membership)=>membership.productInfo.id.toString() === id.toString());
        // checkMyTicket이 존재하고 구독권의 경우는 true로 중복 결제 막기
        if (checkMyTicket && checkMyTicket.productInfo && checkMyTicket.productInfo.category.includes("subscribe")) {
            return Boolean(checkMyTicket);
        }
        return false;
    }, [
        userMembershipResponse,
        id
    ]);
    const expertDisabledType = useMemo(()=>{
        //엑스퍼트가 하나로 있으면
        if (!userMembershipResponse) return null;
        if (userMembershipResponse.unexpired.find((membership)=>membership.productInfo.category === PassCategory.ExpertSubscription)) {
            return "EXPERT";
        }
        //쏠북플러스가 하나라도 있으면
        if (userMembershipResponse.unexpired.find((membership)=>membership.productInfo.category === PassCategory.Subscription || membership.productInfo.category === PassCategory.Solvookplus || membership.productInfo.categoryTitle === "쏠북 플러스" && membership.productInfo.category === PassCategory.Ticket)) {
            return "SOLVOOKPLUS";
        }
        return null;
    }, [
        userMembershipResponse,
        id
    ]);
    useEffect(()=>{
        //구매하려는 상품과 동일한 상품이 있다면
        if (isSamePass) {
            setErrorCode(errorStatus.alreadySubscribe);
            return;
        }
        //결제페이지
        if (path === "checkout") {
            //구매하려는 상품이 엑스퍼트라면 쏠북플러스는 이용중이면 안됨.
            if (subscribePass && subscribePass.category === PassCategory.Expert) {
                if (expertDisabledType === "SOLVOOKPLUS") setErrorCode(errorStatus.alreadySolvookPlus);
                return;
            }
        }
    }, [
        isSamePass,
        expertDisabledType,
        path,
        id,
        subscribePass
    ]);
    return {
        id,
        errorCode,
        subscribePass,
        isError,
        errorMessages
    };
};
export default useCheckMyPass;
